import i18n from "@/i18n";

export const authorizationsFields = [
    {
        key: "authorized",
        label: "",
        tdClass: "dot-column"
    },
    {
        key: "credentialsName",
        label: i18n.t("common.name"),
        sortable: true
    },
    {
        key: "username",
        label: i18n.t("authorization.account"),
        sortable: true
    },
    {
        key: "id",
        label: i18n.t("authorization.authorizationId"),
        sortable: true
    },
    {
        key: "flowType",
        label: i18n.t("authorization.flowType"),
        sortable: true
    },
    {
        key: "actions",
        label: ""
    }
];
